import React, { useState } from "react";
import { Modal, Form } from "react-bootstrap";
import theme from "../../styles/theme/theme";
import AppButton from "../buyer/AppButton";

const RejectReasonModal = ({ show, onHide, onSubmit }) => {
  const [reason, setReason] = useState("");

  const handleSubmit = () => {
    if (reason.trim()) {
      onSubmit(reason);
      setReason("");
      onHide();
    }
  };

  const handleClose = () => {
    setReason("");
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header
        style={{
          backgroundColor: theme.palette.background.paper,
          borderBottom: `2px solid ${theme.palette.secondary.main}`,
        }}
      >
        <Modal.Title
          style={{
            fontWeight: 600,
            fontSize: "1.25rem",
            color: theme.palette.text.primary,
          }}
        >
          Reject Bid
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ backgroundColor: theme.palette.background.paper }}>
        <Form.Group controlId="rejectReason" className="mb-4">
          <Form.Label
            style={{ fontWeight: 500, color: theme.palette.text.primary }}
          >
            Reason for rejection
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Enter reason"
            style={{
              borderRadius: 8,
              padding: "10px 14px",
              border: `1px solid ${theme.palette.tertiary.main}`,
              fontSize: "0.95rem",
              color: theme.palette.text.primary,
              resize: "none",
            }}
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer
        style={{
          backgroundColor: theme.palette.background.paper,
          borderTop: `2px solid ${theme.palette.secondary.main}`,
        }}
      >
        <div style={styles.modalButtons}>
          <AppButton
            variant="outlined"
            onClick={handleClose}
            style={{ marginRight: 12 }}
          >
            Cancel
          </AppButton>
          <AppButton
            variant="contained"
            color="error"
            onClick={handleSubmit}
            disabled={!reason.trim()}
          >
            Reject
          </AppButton>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default RejectReasonModal;

const styles = {
  modalButtons: {
    width: 250,
    display: "flex",
    justifyContent: "flex-end",
  },
};
